import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import { fetchAnonymousUser } from "./thunk";

export interface AnonymousUserState {
  token: string;
  error: string | null;
  status: "idle" | "fetching" | "saving";
}

const initialState: AnonymousUserState = {
  token: "",
  error: null,
  status: "idle"
};

export const anonymousUserSlice = createSlice({
  name: "anonymousUser",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => ({
        ...state,
        ...action.payload[anonymousUserSlice.name]
      }))
      .addCase(fetchAnonymousUser.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchAnonymousUser.fulfilled, (state, action) => {
        state.status = "idle";
        state.token = action.payload.token;
      })
      .addCase(fetchAnonymousUser.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      });
  }
});
